import { Component, Input, TemplateRef } from '@angular/core';
import { DatagridActionHandler, Unsubscriber } from '@core-lib/classes';
import { IColumnSettings, IDatagridSettings, IDatagridSort, IList } from '@core-lib/models';

@Component({
    selector: 'data-table',
    templateUrl: './data-table.component.html',
    styles: [],
    standalone: false
})
export class DataTableComponent<Item, SortableCols> extends Unsubscriber {
	@Input() datagridHandler: DatagridActionHandler<SortableCols>;
	@Input() settings: IDatagridSettings<SortableCols>;
	@Input() withPagination = true;
	@Input() translationPath: string = '';
	@Input() actionPermission: string = '';
	@Input() columnSettings: Array<IColumnSettings> = [];

	@Input() withActions: boolean = true;
	@Input() buttonActions: TemplateRef<any>;
	@Input() SpecialColumnTreatement: TemplateRef<any>;

	@Input() list: IList<Item>;
	selectedRow: number = null;

	constructor() {
		super();
	}

	selectRow(i) {
		if (this.selectedRow == null || this.selectedRow != i) {
			this.selectedRow = i;
		} else {
			this.selectedRow = null;
		}
	}

	onSetSort(column: SortableCols): void {
		const currentSort = this.settings.sort;
		const isSameCol = column === currentSort.column;

		const sort: IDatagridSort<SortableCols> = {
			column,
			isAsc: isSameCol ? !currentSort.isAsc : true
		};
		this.datagridHandler.setSort(sort);
	}

	getSortClasses(column: SortableCols): object {
		const currentSort = this.settings.sort;
		const isSameCol = column === currentSort.column;

		return {
			'col-sorted-asc': isSameCol && currentSort.isAsc,
			'col-sorted-desc': isSameCol && !currentSort.isAsc
		};
	}
}
